import { createContext } from 'react';
import { useAnnotationLabels } from './hooks';

export type AnnotationLabelsContextType = ReturnType<typeof useAnnotationLabels>;

export const AnnotationLabelsContext = createContext<AnnotationLabelsContextType | null>(null);
